module.exports = __webpack_public_path__ + "static/media/Team 33 Powered Up da2fe205-a9a3-4eae-9f3c-031649ea0fdc - Eva Lees.63a05a04.JPG";